import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { carlsbadNmConfig } from "./data";

export default function CarlsbadNmPage() {
  return <CityPageTemplate config={carlsbadNmConfig} />;
}